export enum GameRedirectionSource {
  Game,
  Lobby,
  PreLobby,
  Popup,
  Tournament,
  Cashback,
  PromoCode,
  Freebet,
  Banner,
  TopWins
}
